import CityPageTemplate from "../city-template/CityPageTemplate";
import { akronConfig } from "./data";

export default function AkronPage() {
  return <CityPageTemplate config={akronConfig} />;
}